import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { getTeamsV2PageUrl } from 'utils/url';
import { DataCellProps } from '../types';

export const TenantNameCell = ({ _customRowProps, tenant }: DataCellProps) => {
  return (
    <Link
      to={getTeamsV2PageUrl({ tenant: tenant.tenantName })}
      style={{ color: 'inherit', textDecoration: 'none' }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        component="span"
        sx={{
          cursor: 'pointer',
          color: 'primary.main',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {tenant.tenantName}
      </Box>
    </Link>
  );
};
